import { Component } from '@angular/core';
import { HvtSection3Dto } from '../../../models/notices/ojeu.notice.models';
import { FormType } from '../../../models/notices/ojeu.notice.enums';
import { HvtSectionBase } from './hvt.section.base';

@Component({
    selector: 'hvt-s3',
    template: require('./hvt.section.3.component.html')
})
export class HvtS3Component extends HvtSectionBase<HvtSection3Dto> {
    hvtS3: HvtSection3Dto;
    isF03: boolean;
    isF24: boolean;

    noticeType: string;
    noticeTypeCapitalised: string;

    populate(hvtS3: HvtSection3Dto, formType: FormType) {
        this.hvtS3 = hvtS3;
        this.formType = formType;
        this.isF03 = formType === FormType.F032014;
        this.isF24 = formType === FormType.F242014;

        this.noticeType = this.isF24 ? 'concession' : 'contract';
        this.noticeTypeCapitalised = this.isF24 ? 'Concession' : 'Contract';
    }

    clear() {
        this.hvtS3 = null;
        this.formType = null;
    }

    showSectionIII1s2() {
        return this.formType !== FormType.F212014 && this.formType !== FormType.F232014;
    }

    showSectionIII1s3() {
        return this.formType !== FormType.F212014 && this.formType !== FormType.F232014;
    }

    showSectionIII1s4() {
        return this.formType === FormType.F052014 || this.formType === FormType.F212014 || this.formType === FormType.F232014 || this.formType === FormType.F042014;
    }

    showSectionIII1s6() {
        return this.formType === FormType.F052014;
    }

    showSectionIII1s7() {
        return this.formType === FormType.F052014;
    }

    showSectionIII1s8() {
        return this.formType === FormType.F052014;
    }

    showSectionIII2s1() {
        return this.hvtS3.particularProfession || this.hvtS3.referenceToLaw;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.3.component.ts